import {allGojiras, currentGojira, currentGojiraState} from '$lib/state/gojiras';
import {currentSettingsState} from '$lib/state/settings';
import {get, writable} from 'svelte/store';

export type SaveGojiraFlow = {
  step: 'IDLE' | 'CONFIRM' | 'BLOCKER';
  message?: string;
};

const saveGojiraFlowStore = writable<SaveGojiraFlow>({step: 'IDLE'});

function actualSave() {
  allGojiras.saveCurrent();
}

export const saveGojiraFlow = {
  subscribe: saveGojiraFlowStore.subscribe,
  save() {
    const settingsState = get(currentSettingsState);
    if (settingsState.changed || !settingsState.inList) {
      saveGojiraFlowStore.set({step: 'BLOCKER', message: `Please save the gojira settings first`});
      return;
    }

    const state = get(currentGojiraState);
    if (state.inList && state.changed) {
      const gojira = get(currentGojira);
      saveGojiraFlowStore.set({
        step: 'CONFIRM',
        message: `Do you want to override the existing Gojira named "${gojira.name}"?`,
      });
    } else {
      actualSave();
    }
  },
  confirm() {
    actualSave();
    saveGojiraFlowStore.set({step: 'IDLE'});
  },
  cancel() {
    saveGojiraFlowStore.set({step: 'IDLE'});
  },
};
